<template>
  <div class="version-badge" aria-hidden="true">
    <div><span class="label">panel</span>{{ panel }}</div>
    <div><span class="label">api</span>{{ api }}</div>
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "@/utils/apiBase";

export default {
  name: "VersionBadge",

  data() {
    return {
      // Injected at build time by the deploy workflow. "dev" when running from
      // `npm run serve`, where there is no build to identify.
      panel: process.env.VUE_APP_VERSION || "dev",
      api: "…",
    };
  },

  mounted() {
    // Plain axios, not customAxios: that instance carries the auth token and a
    // 401 interceptor that clears the session and redirects to /login. This
    // endpoint needs neither, and a version lookup must never be able to sign
    // someone out.
    axios
      .get(`${API_BASE_URL}/version`, { timeout: 5000 })
      .then(({ data }) => {
        this.api = data && data.version ? data.version : "unknown";
      })
      .catch(() => {
        // Unreachable backend is itself worth seeing — it is the likeliest
        // reason the panel appears broken.
        this.api = "unreachable";
      });
  },
};
</script>

<style scoped>
/* Last item in the sidebar's flex column, so it settles just above the
   footer separator and the profile link below it. It used to be
   position:fixed in the bottom-left corner, where it overlapped that
   button. Bottom spacing comes from .nav-footer's own margin-top. */
.version-badge {
  display: flex;
  flex-direction: column;
  gap: 1px;

  padding: 0.5rem 0.6rem 0;

  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 11px;
  line-height: 1.35;
  color: #6c757d;
  opacity: 0.75;

  /* Decoration, not a control — never intercept a click meant for the link
     beneath it, and never get read out by a screen reader. */
  pointer-events: none;
  user-select: none;
  white-space: nowrap;
}

.label {
  display: inline-block;
  width: 3.2em;
  color: #adb5bd;
}
</style>
